export interface Klient {
    id: number;
    nazwa: string;
    nip: string;
    regon: string;
    krs: string;
    pesel: string;
    adres: string;
    typ: TypKlienta;
    numerRachunkuPodatki: string;
    numerRachunkuZUS: string;
}

export enum TypKlienta {
    KF = 'KF', // JDG
    KO = 'KO', // Księga Handlowa
    KZ = 'KZ',
  }

export interface KlientAlternatywny {
    id: number;
    nazwa: string;
}

export interface Moduly {
    nieaktywne: string[];
    dodatkowe: string[];
}
